import { useSelector } from "react-redux";

export const   useAdaptedFields = () => {
    const rawFieldList = useSelector((state) => state.fieldsList.categories);
    const fieldOptions = useSelector((state) => state.fieldOptions.options);

    const typeMap = {
        string: "text",
        text: "textarea",
        datetime: "datetime",
        int: "number",
        float: "number",
        boolean: "boolean",
        single_choice_enum: "dropdown",
        multi_value: "multiselect"
    };

    const adaptFieldsFromApi = () => {
        if (!Array.isArray(rawFieldList)) return [];

        return rawFieldList.map((category) => ({
            category: category.category,
            categoryAttention: category.note,
            fields: category.fields.map((field) => {
                const isUrl = typeof field.options === "string";
                const resolvedOptions = isUrl ? fieldOptions[field.name] || [] : field.options;

                return {
                    label: field.label || field.alias || field.name,
                    name: field.name,
                    type: typeMap[field.type] || "text",
                    options: resolvedOptions,
                    validationRules: {
                        required: field.required === true
                    },
                    fieldStructure: field
                };
            })
        }));
    };

    return adaptFieldsFromApi();
};